import * as React from 'react'

import { cn } from '@/lib/utils'

/** Bloco de carregamento. Sempre com `aria-hidden`: não é conteúdo. */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      aria-hidden="true"
      data-slot="skeleton"
      className={cn('animate-pulse rounded-lg bg-elevated', className)}
      {...props}
    />
  )
}

export { Skeleton }
